import React, {useRef} from 'react'
import styles from '../componentsStyles/AboutIntro.module.css'

import {motion, useScroll, useTransform} from 'framer-motion'

const AboutIntro = () => {

    const introRef = useRef(null);

    const {scrollYProgress} = useScroll({
        target: introRef,
        offset:["start end", "end end"]
    })

    const opacity1 = useTransform(scrollYProgress,
    [0.2, 0.4],
    [1, 0]    
    )
    const x = useTransform(scrollYProgress,
    [0.30, 0.35, 0.4],
    ["0%", "-25%","-50%"]    
    )

    const x2 = useTransform(scrollYProgress,
    [0.55, 0.58, 0.6],
    ["0%", "-25%","-50%"]    
    )
    const opacity2 =useTransform(scrollYProgress,
    [0.4, 0.5 ,0.6],
    [0, 1, 0]    
    )

    const x3 = useTransform(scrollYProgress,
    [0.75, 0.80, 0.9],
    ["0%", "-25%","-50%"]    
    )
    const opacity3 =useTransform(scrollYProgress,
        [0.6, 0.8, 0.9],
        [0, 1, 0 ]    
    )

    const outTheWay = useTransform(scrollYProgress,(pos)=>{
        return pos === 9 ? "relative": "fixed"
    } )

  return (
    <div className={styles.aboutIntroComponent}>

            <div className={styles.introBgHeight}>
                <div className={styles.introBg}>
                    <img src="./images/black-ice.jpg" alt="..." />
                </div>
            </div>

           
            <motion.div className={`${styles.textContainer} ${styles.slide1}`} style={{opacity: opacity1}}>

                <div className={styles.imgTextContainer}>
                <img src="./images/code.jpg" alt=".." />
                </div>

                <motion.div className={styles.text} style={{x}}>
                    <h3>
                    Hello, im M.Lima, fullstack web developer with experience on building websites and small applications.
                    </h3>
                    <p>
                    With experience in React.js and proficiency in html and css as a base, i typically rely on javaScript/TypeScript to handle backend operations in every project i work on.
                    </p>
            
                </motion.div>
            </motion.div>

            <motion.div className={`${styles.textContainer} ${styles.slide2}`} style={{opacity: opacity2}}>

                <div className={styles.imgTextContainer}>
                <img src="./images/fe.png" alt=".." />
                </div>

                <motion.div className={styles.text} style={{x: x2}}>
                    <h3>
                    I mainly use React.js in the frontend of my projects.
                    </h3>
                    <p>
                    It's easy to follow the design planning and integrate the website with the backend.
                    </p>
                    <p>
                    React guarantees very high performance that results in a good user experience.
                    </p>
            
                </motion.div>
            </motion.div>


            <motion.div className={`${styles.textContainer} ${styles.slide2}`} style={{opacity: opacity3, position: outTheWay}}>

                <div className={styles.imgTextContainer}>
                <img src="./images/servers.jpg" alt=".." />
                </div>

                <motion.div className={styles.text} style={{x: x3}}>
                    <h3>
                    To make my projects work i use JavaScript/Typescript tools in the back-end.
                    </h3>
                    <p>
                    Using JS/TS in the backend makes the development process faster, being the primary language in the node environment.
                    </p>
                    <p>
                    TypeScript is the best option in high-level languages ​​to achieve type safety, ensuring no data loss between client and server operations.
                    </p>
            
                </motion.div>
            </motion.div>





        <div className={styles.introHeight} ref ={introRef}>


            <div className={styles.introSticky }>

                
                <div className={styles.introCenter }>
                    <div className={styles.introImgContainer}>
                        <img src="./images/Subtract.png" alt="..." />
                    </div>

                </div>

            </div>

        </div>

     
    </div>
  )
}

export default AboutIntro